import React from 'react'
import { Line } from 'react-chartjs-2'
import { Options } from './options'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
)

export interface DataSet {
  label: string
  data: any[]
  fill?: string
  fillColor?: string
  backgroundColor: string
  borderColor?: string
  borderWidth?: number
  pointColor?: string
  pointStrokeColor?: string
  pointHighlightFill?: string
  pointHighlightStroke?: string
}

interface Props {
  labels: any[]
  datasets: DataSet[]
  options?: any
}

const LineChart: React.FC<any> = ({ labels, datasets, options }: Props) => {
  const data = {
    labels: labels,
    datasets: datasets,
  }
  const lineOptions = Options(data.labels)

  return <Line options={{ ...lineOptions, ...options }} data={data} />
}

export default LineChart
